KBbanner = {
    init: function(){
        console.log('init')
        $('.sqare-banners-wrap .podcast').click(function (){
            $(this).find('.menu').css('transform', 'translateX(0)');
            $(this).find('span').css('filter', 'blur(3px)')
        })
    },
}
